import { RootState } from '@store/rootReducer'

export const selectGraphicPacks = (state: RootState) => state.editor.graphicPacks.graphicPacks
